/**
 * @author Abdul Aziz
 * @description Common Constant strings
 */

 export const SHOW_NOTIFICATION = 'show_notification';
 export const CLICK_NOTIFICATION = 'click_notification';
 export const CHAT_NOTIFICATION = 'chat';
 export const APPOINTMENT_NOTIFICATION = 'appointment';
 export const LOGIN = 'login';
 export const LOGOUT = 'logout';